import { OrderNotice, OrderNoticeType } from '../model/vo';

/** 출장비 누락 안내 유형 (BuyResponse.Notice.type) */
export const ORDER_NOTICE_TRIP_FEE_MISSING_TYPE: OrderNoticeType =
  'VISIT_FEE_REQUIRED';

/** 출장비 초과 안내 유형 (BuyResponse.Notice.type) */
export const ORDER_NOTICE_TRIP_FEE_DUPLICATE_TYPE: OrderNoticeType =
  'VISIT_FEE_DUPLICATE';

export interface OrderNoticeConfirm {
  /** 컨펌 본문 (BE notice.message — 줄바꿈 포함) */
  content: string;
  /** 주문 계속 진행 */
  confirmText: string;
  /** 주문 중단 */
  cancelText: string;
  /** 취소 시 출장비 상품을 옵션 드로워에 자동 추가해야 하는지 */
  isAddTripFee: boolean;
}

/**
 * 주문 응답의 notice 를 컨펌창 표시 정보로 해소한다. (HSMALL-16745)
 *
 * BE 계약: 응답 code 는 정상과 동일하게 200 이고, 체크룰에 걸린 경우에만
 * data.notice = { type, message } 가 실려온다. 판정과 문구는 BE 가 소유하므로
 * (message 에 줄바꿈까지 포함) 프론트는 notice 에 없는 버튼 라벨만 결정한다.
 * → 출장비 누락(VISIT_FEE_REQUIRED)만 옵션 드로워 자동 추가가 가능해 `출장비 추가` 를
 *   제공하고, 그 외 유형(초과 VISIT_FEE_DUPLICATE 포함)은 `수정하기` 로 드로워 수정을 안내한다.
 *
 * @param canAddTripFee 출장비 자동 추가가 가능한 경로인지 (패키지 주문은 불가)
 */
export const resolveOrderNoticeConfirm = ({
  notice,
  canAddTripFee = true,
}: {
  notice?: OrderNotice | null;
  canAddTripFee?: boolean;
}): OrderNoticeConfirm | undefined => {
  if (!notice?.message) return undefined;

  const isAddTripFee =
    notice.type === ORDER_NOTICE_TRIP_FEE_MISSING_TYPE && canAddTripFee;

  return {
    content: notice.message,
    confirmText: '이대로 구매',
    cancelText: isAddTripFee ? '출장비 추가' : '수정하기',
    isAddTripFee,
  };
};
